/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Papa from 'papaparse';

/* Import types */
import type { SensorCsvRow } from '@/types/sensorCsv';

/* Import libraries */
import { getSensorCsvSelection } from '@/lib/sensors/csv/sensorCsv';

export interface SensorDescriptionEntry {
    description: string
    subsensors: Record<string, string>
}

export type SensorDescriptionsMap = Record<string, SensorDescriptionEntry>

export function csvToSensorDescriptions(csv: string): SensorDescriptionsMap {
    const parsedCsv = Papa.parse<SensorCsvRow>(csv, {
        delimiter: ';',
        header: true,
        skipEmptyLines: true,
    });

    return parsedCsv.data.reduce<SensorDescriptionsMap>((accumulator, row) => {
        if (row.Enabled !== '1' || !row.Sensor || !row.Description) {
            return accumulator;
        }

        const sensorSelection = getSensorCsvSelection(row.Sensor);

        if (!sensorSelection) {
            return accumulator;
        }

        const { deviceName: meterKey, sensorType: subsensor } = sensorSelection;
        const description = row.Description.trim();

        if (!accumulator[meterKey]) {
            accumulator[meterKey] = {
                description,
                subsensors: {},
            };
        }

        accumulator[meterKey].subsensors[subsensor] = description;

        return accumulator;
    }, {});
}
